import fetchStateFromHtml from '@PROJECT_ROOT/assets/shared/js/fetchStateFromHtml';

$(() => {
    const objectType = fetchStateFromHtml();
    const accTypeSelected = $('#accTypeSelected');
    const accTypeList = $('#accTypeList');
    const loader = $('#newLoader');
    const searchFormWrap = $('#searchFormWrap');

    const formsUrl = {
        private: { simple: objectType.private },
        charter: { simple: objectType.charter },
        lighthouse: { simple: objectType.lighthouse },
    };

    const changeAccType = function changeAccommodationType(type) {
        $.ajax({ url: formsUrl[type].simple,
            beforeSend: () => {
                searchFormWrap.empty();
                loader.show();
            },
            success: (data) => {
                loader.hide();
                $('.advancedSearchToHide').show();
                searchFormWrap.html(data);

                $(document).on('click', '#advancedSearch', () => {
                    $.cookie('advanced_search', 1, { path: '/' });
                });
            },
        });
    };
    let initType = accTypeList.find('.active').data('value');
    if (!initType) {
        const typePrivate = accTypeList.find('.private').addClass('active');
        accTypeSelected.text(typePrivate.text());
        initType = 'private';
    }
    changeAccType(initType);

    if (!$('#accTypeSelectedWrap').hasClass('disabled')) {
        accTypeSelected.on('click', function accommodationTypeSelected(e) {
            e.stopPropagation();
            $(this).parent().toggleClass('active');
            accTypeList.toggle();
        });
    }
    accTypeList.on('click', 'li', function accommodationTypeList() {
        const that = $(this);
        changeAccType(that.data('value'));
        accTypeSelected.attr('class', that.data('value')).text(that.text());
        accTypeList.find('li').removeClass('active');
        that.addClass('active');
    });

    $('body').on('click', () => {
        if (accTypeSelected.parent().hasClass('active')) {
            accTypeSelected.parent().removeClass('active');
            accTypeList.hide();
        }
    });

    $('#accTypeSelectedWrap').on('click', '.autocompleteAll', (e) => {
        e.stopPropagation();
        accTypeSelected.click();
    });
});
